// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qIeL","top":"styles_top__2_F-7"};